import { configureStore } from "@reduxjs/toolkit";
import AdminSlice from "../FunctionComponents/Redux/AdminSlice";
import questionsReducer from "../store/questionsSlice";
import queriesAnswerReducer from "../store/queriesAnswerSlice";
import postQuestionReducer from "../store/postQuestionSlice";
import commentsReducer from "../store/commentsSlice";
import hallOfFameReducer from "../store/hallofFameSlice";
import dashboardReducer from "../store/dashboardSlice";
import metricsReducer from "../store/metricsSlice";
import employeeReducer from "../store/employeeSlice";
import userRolesReducer from "../store/UserMaintanence";
import tagReducer from "../store/tagSlice";
import searchReducer from "../store/searchSlice";
import aiAnswerReducer from "../store/aiAnswerSlice";

export default configureStore({
 reducer: {
  admin: AdminSlice,
  questions: questionsReducer,
  queriesAnswer: queriesAnswerReducer,
  postQuestion: postQuestionReducer,
  comments: commentsReducer,
  hallOfFame: hallOfFameReducer,
  dashboard: dashboardReducer,
  metrics: metricsReducer,
  employees: employeeReducer,
  userRoles: userRolesReducer,
  tags: tagReducer,
  search: searchReducer,
  aiAnswer: aiAnswerReducer
 },
});
